import { stringBytes } from '@/common/util/string'

const LOCAL_STORAGE_BYTE_MAX = 5 * 1024 * 1024

export enum LocalStorage {
  AUTH_TOKEN = 'w2_token',
  // CURRENT_SITE_ID = 'w2_selected_site',
  // SCREEN_MODE = 'w2_mode',
  MESSAGES = 'MESSAGES',
  PREV_URL = 'PREV_URL',
  // ログイン画面で「プロジェクト番号とメールアドレスを記憶する」が ON のとき保存（JSON）
  LOGIN_REMEMBER = 'w2_login_remember'
}

export const saveStorage = (key: LocalStorage, value: string) => {
  localStorage.setItem(key, value)
}

export const loadStorage = (key: LocalStorage) => {
  return localStorage.getItem(key)
}

export const removeStorage = (key: LocalStorage) => {
  localStorage.removeItem(key)
}

export const isStorageSavable = (key: LocalStorage, text: string): boolean => {
  return localStorageSpaceBytes([key]) + stringBytes(text) < LOCAL_STORAGE_BYTE_MAX
}

const localStorageSpaceBytes = (excludes: string[] = []) => {
  let allStrings = ''
  for (const key in window.localStorage) {
    if (Object.prototype.hasOwnProperty.call(window.localStorage, key) && !excludes.includes(key)) {
      allStrings += window.localStorage[key]
    }
  }
  return 3 + stringBytes(allStrings)
}
